<aura-edit-wrapper
  [(isEditing)]="isEditing"
  (saved)="saved.emit($event)"
  [showDivider]="true"
  #editWrapper="auraEditWrapper"
>
  @if (editWrapper.isEditing()) {
    <aura-internationalization-language-form
      [dto]="currentLanguage()"
      [requiredFields]="['email']"
      [allReadonly]="!editWrapper.isEditing()"
      (validityChanged)="editWrapper.onValidityChanged($event)"
      (dtoChanged)="editWrapper.onDtoChanged($event)"
    />
  } @else {
    <aura-internationalization-language-display [currentLanguage]="currentLanguage()" />
  }
</aura-edit-wrapper>
